import styled, { keyframes } from 'styled-components';

const buttonTransition = keyframes`
 0% { opacity: 1; }
 25% { opacity: 0.2; }
 50% { opacity: 0; }
 100% {opacity: 1; }
`;

const swipe = ($isOpen: boolean) => keyframes`
 0% { transform: rotate(0); opacity: 1; }
 90% { transform: rotate(${!$isOpen && '-'}40deg); opacity: 0.9; }
 100% {transform: rotate(${!$isOpen && '-'}50deg); opacity: 0; }
`;

export const SwipeButton = styled.button<{ $isOpen: boolean }>`
  width: 48px;
  height: 48px;
  position: fixed;
  bottom: 30%;
  border: none;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background-color: ${({ theme }) => theme.neutral_300};
  z-index: 2;
  animation: ${buttonTransition};

  ${({ $isOpen }) => ($isOpen ? 'left: 0' : 'right: 0')}
`;

export const SwipeAnimation = styled.div<{ $isOpen: boolean }>`
  animation-name: ${({ $isOpen }) => swipe($isOpen)};
  animation-duration: 2.5s;
  animation-iteration-count: 3;
`;

export const DrawerContent = styled.div`
  height: 100vh;
  background-color: ${({ theme }) => theme.neutral_100};
  top: 0;
  position: absolute;
  right: 0px;
  visibility: visible;
  box-shadow: -2px 1px 10px ${({ theme }) => theme.neutral_300};
`;
